var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClimateSensorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4254 15.7331C16.2731 16.335 16.8262 17.3246 16.8262 18.4434C16.8262 20.2779 15.3391 21.7651 13.5046 21.7651C11.67 21.7651 10.1829 20.2779 10.1829 18.4434C10.1829 17.3246 10.736 16.335 11.5838 15.7331V4.92079C11.5838 3.86436 12.4481 2.99999 13.5046 2.99999C14.561 2.99999 15.4254 3.86436 15.4254 4.92079L15.4254 15.7331Z",
    fill: "#062A41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1736 13.6335C10.3895 13.6335 10.5646 13.8086 10.5646 14.0245C10.5646 14.2404 10.3895 14.4154 10.1736 14.4154H8.39094C8.17502 14.4154 8 14.2404 8 14.0245C8 13.8086 8.17502 13.6335 8.39094 13.6335H10.1736Z",
    fill: "#1592D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1736 11.1941C10.3895 11.1941 10.5646 11.3691 10.5646 11.585C10.5646 11.8009 10.3895 11.976 10.1736 11.976H8.39094C8.17502 11.976 8 11.8009 8 11.585C8 11.3691 8.17502 11.1941 8.39094 11.1941H10.1736Z",
    fill: "#1592D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1736 8.75465C10.3895 8.75465 10.5646 8.92968 10.5646 9.14559C10.5646 9.36151 10.3895 9.53653 10.1736 9.53653H8.39094C8.17502 9.53653 8 9.36151 8 9.14559C8 8.92968 8.17502 8.75465 8.39094 8.75465H10.1736Z",
    fill: "#1592D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1736 6.31521C10.3895 6.31521 10.5646 6.49023 10.5646 6.70615C10.5646 6.92206 10.3895 7.09709 10.1736 7.09709H8.39094C8.17502 7.09709 8 6.92206 8 6.70615C8 6.49023 8.17502 6.31521 8.39094 6.31521H10.1736Z",
    fill: "#1592D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8.99999V4.26503C14 4.19255 13.9435 4.12636 13.8526 4.07814C13.7617 4.02996 13.6368 3.99999 13.5 3.99999C13.3632 3.99999 13.2383 4.02993 13.1474 4.07814C13.0565 4.12636 13 4.19255 13 4.26503V8.99999H14Z",
    fill: "#E9EEF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8071 9.99999H13.1929V16.5254H13.1913C13.1912 16.7085 13.0889 16.8825 12.9188 16.958C12.645 17.0794 12.4122 17.2847 12.249 17.5436C12.0917 17.7933 12 18.0941 12 18.4185C12 18.8553 12.1679 19.2507 12.4393 19.5368C12.7107 19.823 13.0857 20 13.5 20C13.9143 20 14.2893 19.823 14.5607 19.5368C14.8321 19.2507 15 18.8553 15 18.4185C15 18.0941 14.9083 17.7933 14.751 17.5436C14.5943 17.295 14.3735 17.0959 14.1138 16.973C13.9357 16.9109 13.8071 16.734 13.8071 16.5254L13.8071 9.99999Z",
    fill: "#55BEF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimateSensorIcon);
export default __webpack_public_path__ + "static/media/ClimateSensorIcon.70f5c42e3c0a74c3a5ddcc467431d7ce.svg";
export { ForwardRef as ReactComponent };